import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import translate from '../../reusable/translate'
import moment from 'moment'
import { getCommitmentTypeId } from '../helpers/Categories'
import ProfilePicture from './ProfilePicture'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import {isMaterialOrGD} from "../helpers/Categories";

import commitmentSlice from '../../../state/slices/commitmentSlice'
import validatorSlice from '../../../state/slices/validatorSlice'


const CreationInfo = ({ fetchedCommitment, dateRef }) => {

    const dispatch = useDispatch()
    const { changeEndDate } = bindActionCreators(commitmentSlice.actions, dispatch)
    const { commitment } = useSelector((state) => state)
    const [selectedCommitment, setSelectedCommitment] = useState('')
    const [commitmentIndustry, setCommitmentIndustry] = useState('')
    const [allowSelectEndDate, setAllowSelectEndDate] = useState(false)
    const [loading, setLoading] = useState(true)
    const [preSetEndDate, setPreSetEndDate] = useState('')

    const organization = fetchedCommitment.organizations.find((org) => org.name === commitment.organizationName)

    const updateOrganizationLogo = async(pic) => {
        await fetch('/o/commitment2050-service/organizationapi/logo', {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache'
            },
            credentials: 'include',
            body: JSON.stringify({
                logo: pic
                    ? pic.split(',')[1]
                    : null,
                organizationId: organization.organizationId
            })
        })
    }


    useEffect(() => {

        const id = getCommitmentTypeId(commitment.commitmentType)
        const fetchCategoryNames = async () => {
            const result =  await fetch(`/o/commitment2050-service/commitmentapi/categories/${id}`).then((res) => res.json())
            let category = result.children.find((child) => child.categoryId === commitment.commitmentCategoryId.toString())
            setSelectedCommitment(category && category.name)
            setCommitmentIndustry(category && category.children.find((child) => child.categoryId === commitment.commitmentSubcategoryId.toString()).name)
            if( !commitment.endDate && category && category.properties.endDate){
                setPreSetEndDate(category.properties.endDate)
            }
            else{
                if(!commitment.endDate) {
                    setAllowSelectEndDate(true)
                }
            }
            setLoading(false)
        }
        if(isMaterialOrGD(commitment.commitmentType)) {
            fetchCategoryNames()
        } else{
            setAllowSelectEndDate(true)
            setLoading(false)
        }
    }, [])

    useEffect( () => {
        if(preSetEndDate) {
            changeEndDate(preSetEndDate)
        }
    },[preSetEndDate])

    if (loading) return null

    return(
        <div className="flex-row border-bottom space-between">
            <div className="flex-column">

                <Row
                    textKey={'sit.commitmentCreation.creator'}
                    text={commitment.organizationName}
                />

                {selectedCommitment &&
                <Row
                    textKey={'sit.commitmentCreation.selectedCommitment'}
                    text={selectedCommitment}
                />}

                {commitmentIndustry &&
                <Row
                    textKey={'sit.commitmentCreation.commitmentIndustry'}
                    text={commitmentIndustry}
                />}

                <Row
                    textKey={'sit.commitmentCreation.startingDate'}
                    text={commitment.startDate
                        ? moment(commitment.startDate).format('DD.MM.YYYY')
                        : (new Date()).toLocaleDateString('fi-FI')}
                />

                <EndDateContainer 
                    dateRef={dateRef} 
                    allowSelectEndDate={allowSelectEndDate} 
                    commitment={commitment}
                />

            </div>

            {organization &&
            <ProfilePicture
                profilePic={organization.logo}
                onSelect={updateOrganizationLogo}
            />
            }

        </div>
    )}
export default CreationInfo

const Row = ({ textKey, text }) => {
    return(
        <div className="grid35">
            <b>{translate({ textKey: textKey })}</b>
            <p className="p">{text}</p>
        </div>
    )
}

const EndDateContainer = ({ dateRef, allowSelectEndDate, commitment }) => {


    const { language, validators } = useSelector((state) => state)
    const dispatch = useDispatch()
    const { changeDateValidator } = bindActionCreators(validatorSlice.actions, dispatch)
    const { changeEndDate } = bindActionCreators(commitmentSlice.actions, dispatch)


    return(
        <div className="grid35">
            <b>{translate({ textKey: 'sit.commitmentCreation.endDate' })}</b>
            <div ref={dateRef}>
                {!allowSelectEndDate
                    ? <p className="p">{moment(commitment.endDate).format('DD.MM.YYYY')}</p>
                    : <DatePicker
                        className={`input-padding ${validators.date ? '' : 'select-validated'}`}
                        selected={
                            commitment.endDate
                                ? moment(commitment.endDate)
                                : null
                        }
                        onChangeRaw={(e) => {
                            e.preventDefault()
                            return false
                        }}

                        onChange={(date) => {
                            changeEndDate(date.toJSON())
                            changeDateValidator(true)
                        }}

                        placeholderText={translate({
                            languageOverride: language,
                            textKey: 'sit.commitment.operations.chooseEndingDate'
                        })}
                        minDate={moment()}
                    />
                }
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/materialCommitment/commitment/CreationInfo.jsx